import { render, staticRenderFns } from "./CheckBoxInputList.vue?vue&type=template&id=64fb2db7&"
import script from "./CheckBoxInputList.vue?vue&type=script&lang=ts&"
export * from "./CheckBoxInputList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports